module.exports = __webpack_public_path__ + "img/SEGURIFY_GIF_ANA_200x644_030822.b31d7cec.gif";